export default __webpack_public_path__ + "static/media/KAAN02.d085e008.png";